import { Grid, Typography } from '@mui/material';
import { FormSection } from '@components/forms';
import { TFormField } from '@models/forms';
import { GetAppointedLink } from '@pages/Login/SignUpView/GetAppointedLink';

export const BrokerPartnerIdSection = ({ partnerFields }: { partnerFields: { [fieldName: string]: TFormField } }) => (
  <>
    <Grid size={{ xs: 12 }} sx={{ mt: -1, textAlign: 'left' }}>
      <Typography variant='caption' sx={{ color: 'text.caption' }}>
        Enter your LIO Partner ID that was provided to you or your LIO appointed brokerage. ( <GetAppointedLink />)
      </Typography>
    </Grid>
    <Grid size={{ xs: 12 }}>
      <FormSection fields={partnerFields} styleConfig={{ spacing: 0 }} />
    </Grid>
  </>
);
